module.exports = __webpack_public_path__ + "img/qu_ca.32a330c.jpg";